
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { LocalStorage } from 'ngx-store';

//Model
import { TaskNotification } from './tasknotifications.model';
import { Url } from '../../model/users.model';

@Injectable()
export class TaskNotificationsService {
    @LocalStorage() url: Url;

    private headers = new Headers({ 'Content-Type': 'application/json' });

    constructor(public http:HttpClient) { 
    }

    // Http Headers
    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json'
        })
    }



    getTaskNotifications(id:number) {
        return this.http.get(this.url.rest  + '/tms/getTaskNotifications/' + id, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )    
    }


    updateTaskNotifications(taskNotifications: TaskNotification): Observable<TaskNotification[]> {
      return this.http.post<TaskNotification[]>(this.url.rest  + '/tms/updateTaskNotifications', taskNotifications, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )    
    }



    private extractData(res: Response) {
        let body = res.json();
        console.log(body);
        if(body)
            return body || {};
        else
            return null;
    }
    // Error handling
    handleError(error) {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
            // Get client-side error
            errorMessage = error.error.message;
        } else {
            // Get server-side error
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        console.log(errorMessage);
        return throwError(errorMessage);
    }
}